import { render, staticRenderFns } from "./my-tests.vue?vue&type=template&id=0ed8bc1c&scoped=true&"
import script from "./my-tests.vue?vue&type=script&lang=js&"
export * from "./my-tests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8bc1c",
  null
  
)

export default component.exports